//@author: devin

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
    inject,
} from "@angular/core";
import { S25EditableAbstract } from "../s25.editable.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
@TypeManagerDecorator("s25-ng-editable-textarea")
@Component({
    selector: "s25-ng-editable-textarea",
    template: `
        @if (readOnly()) {
            @if (renderHtml()) {
                <span class="s25-data" [innerHTML]="valueToRender()" [class.fade-preview]="fadePreview"></span>
            } @else {
                <span class="s25-data" [innerText]="valueToRender()" [class.fade-preview]="fadePreview"></span>
            }
        } @else {
            <div>
                @if (!editing) {
                    <button
                        type="button"
                        class="s25-editable-shared-container c-editable-text editable editable-click"
                        [class.fade-preview]="fadePreview"
                        [id]="fieldId()"
                        (click)="editMode()"
                    >
                        @if (renderHtml()) {
                            <div class="s25-editable s25-data" [innerHTML]="valueToRender()"></div>
                        } @else {
                            <div class="s25-editable s25-data" [innerText]="valueToRender()"></div>
                        }
                    </button>
                }
                @if (editing) {
                    <div>
                        <textarea
                            class="firstFocusEditable"
                            [minlength]="min()"
                            [maxlength]="max()"
                            [disabled]="disabled()"
                            [ngModel]="candidateVal"
                            [rows]="rows"
                            [cols]="cols"
                            (ngModelChange)="update($event)"
                            (blur)="onInputBlur()"
                            [id]="fieldId()"
                        ></textarea>
                        <div class="aw-button-group">
                            @if (hasCancelButton) {
                                <button
                                    class="aw-button aw-button--outline"
                                    (click)="cancel()"
                                    (keyup.enter)="cancel()"
                                >
                                    {{ cancelButtonText }}
                                </button>
                            }
                            @if (hasCommitButton) {
                                <button
                                    class="aw-button aw-button--primary"
                                    (click)="commit()"
                                    (keyup.enter)="commit()"
                                >
                                    {{ commitButtonText }}
                                </button>
                            }
                        </div>
                        @if (errorMessages) {
                            <div>
                                @for (msg of errorMessages; track msg) {
                                    <div class="ngRed ngBold">
                                        {{ msg }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        }
    `,
    styles: `
        .s25-data {
            display: block;
            overflow-wrap: break-word;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25EditableTextareaComponent extends S25EditableAbstract<string> implements OnInit, OnChanges {
    readonly renderHtml = input(false);

    readonly valueToRender = computed(() => {
        const value = this.readOnly() ? this.value() : this.value() || this.placeholder || "";
        if (this.renderHtml()) {
            return this.convertNewlinesToBr(value);
        } else {
            return value;
        }
    });

    getType = () => "textarea";

    private readonly cd = inject(ChangeDetectorRef);
    private readonly sanitizer = inject(DomSanitizer);

    ngOnChanges(changes: SimpleChanges) {
        if (changes["val"]) {
            this.candidateVal = this.val;
            this.cd.markForCheck();
        }
    }

    ngOnInit() {
        super.ngOnInit();
    }

    convertNewlinesToBr(text: any): SafeHtml {
        if (text === null || text === undefined) return "";
        const html = String(text).replace(/\n/g, "<br/>");
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
